import React from "react";

export default function Slogen({
  tag,
  slogen,
  subSlogen,
}: {
  tag: string;
  slogen: any;
  subSlogen?: string;
}) {
  return (
    <div className="bg-secondary-light px-8 sm:px-10 py-20 sm:py-24 flex flex-col items-center text-center relative">
      <span className="absolute top-0 left-1/2 -translate-x-1/2 h-10 w-px bg-main/50"></span>
      <p className="text-[11px] tracking-[0.3em] uppercase text-secondary-dark/60 font-text">
        {tag}
      </p>
      {slogen && (
        <div className="font-header leading-relaxed text-2xl sm:text-3xl pt-6 text-secondary-dark max-w-[760px]">
          {slogen}
        </div>
      )}
      {subSlogen && (
        <p className="max-w-[560px] text-sm font-light font-text leading-7 pt-12 text-secondary-dark/75">
          {subSlogen}
        </p>
      )}
    </div>
  );
}
